import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Map } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { apiClient, getApiErrorMessage } from "../../lib/apiClient";

export function DriverMapCard() {
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    apiClient
      .get("/outlet/driver-map")
      .then(({ data }) => setEnabled(Boolean(data.driver_map_enabled)))
      .catch(() => setEnabled(true))
      .finally(() => setLoading(false));
  }, []);

  const toggle = async () => {
    const next = !enabled;
    setEnabled(next);
    setSaving(true);
    try {
      await apiClient.put("/outlet/driver-map", { driver_map_enabled: next });
      toast.success(next ? "Drivers can now view the route map." : "Route map hidden from drivers.");
    } catch (error) {
      setEnabled(!next);
      toast.error(getApiErrorMessage(error, "Could not update setting."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card data-testid="settings-driver-map-card">
      <CardContent className="p-5">
        <div className="flex items-start gap-3">
          <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary">
            <Map size={18} strokeWidth={1.5} />
          </span>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold text-text-main">Route map for drivers</p>
            <p className="mt-0.5 text-xs text-text-muted">
              When on, drivers see a "View Map" button at the top of their route for today that opens the full
              delivery map. When off, the button is hidden.
            </p>
          </div>
          <button
            type="button"
            role="switch"
            aria-checked={enabled}
            disabled={loading || saving}
            onClick={toggle}
            data-testid="settings-driver-map-toggle"
            className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors disabled:opacity-50 ${
              enabled ? "bg-accent" : "bg-border"
            }`}
          >
            <span
              className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${
                enabled ? "translate-x-5" : "translate-x-0.5"
              }`}
            />
          </button>
        </div>
      </CardContent>
    </Card>
  );
}
